const t = (e) => `${e?.first_name?.slice(0, 1).toUpperCase()}${e?.last_name?.slice(0, 1).toUpperCase()}`;
export {
  t as getInitial
};
